import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteSellerRes } from "./helper";

const deleteSeller = async (id: number) =>
  axios.delete(Routes.DELETE_SELLER + "/" + id);

export const useDeleteSeller = () =>
  useMutation({
    mutationKey: [Keys.DELETE_SELLER_MUT],
    mutationFn: deleteSeller,
    onSuccess: onDeleteSellerRes,
  });
